<div class="flex flex-col w-full">

    <!-- Header -->
    <div class="flex items-start justify-between" style="padding: 18px 24px; border-bottom: 1px solid #e5e2ee;">
        <div class="flex flex-col min-w-0">
            <h2 class="orange-text font-extrabold text-2xl uppercase">{{ title }}</h2>
            <span class="truncate" style="font-size: 12px; font-weight: 700; color: #222;">{{ fileName }}</span>
        </div>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="flex items-center justify-center flex-shrink-0"
            style="width: 36px; height: 36px; border-radius: 8px; background: #E1742E; color: #fff; cursor: pointer;">
            <iconify-icon icon="mynaui:letter-x-solid" height="24"></iconify-icon>
        </button>
    </div>

    <!-- Body -->
    <div style="padding: 20px 24px 24px;">
        <div
            class="flex items-center justify-center overflow-hidden"
            style="background: #f4f1ec; border-radius: 10px; min-height: 200px;">
            <img
                *ngIf="!loadFailed; else failed"
                [src]="data.imageUrl"
                [alt]="fileName"
                (error)="loadFailed = true"
                class="max-w-full object-contain"
                style="max-height: 60vh;">
            <ng-template #failed>
                <span class="text-xs italic text-gray-500">Unable to load image.</span>
            </ng-template>
        </div>
    </div>
</div>